import { useContext } from 'react';

import { DocumentSettingsContext } from 'components/editor/SidePanel/DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import { getPageSizeForOrientation, type PageSize } from 'components/editor/shared/gridConfig';
import { ContentType } from 'utils/getContentType';
import { useEffectiveOrientation } from './useEffectiveOrientation';
import { selectContentType } from '../components/editor/grid/reduxStore/documentSettingsSlice';
import { useAppSelector } from '../components/editor/grid/reduxStore/Store';

// Single source of truth for the editor canvas page size (width/height, already oriented).
// Not gated by editor-page-size: that flag only controls changing the size, a stored size is always used.
// SECTION content has no page size yet (FEN-4125), so it always uses the orientation-based US Letter size.
export function useEffectivePageSize(): PageSize {
  const { documentSettings } = useContext(DocumentSettingsContext);
  const orientation = useEffectiveOrientation();
  const contentType = useAppSelector(selectContentType);

  if (contentType !== ContentType.SECTION && documentSettings?.pageSize) return documentSettings.pageSize;
  return getPageSizeForOrientation(undefined, orientation);
}
